
import Notification from  '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';
  export default {
  components: {
    Notification: Notification
  },
    data: () => ({
      tableLoading : false,

      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: true,
      insertact: true,
      updateact: true,
      viewact: true,

      analysisGroupRole: [
          v => !!v || 'Fullname is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
        ],

        
      // ====================
      // variable input 
      // ====================
      id_seq:'',
      analysisGroup: '',
      image_url: '',
      statusactive: 1,
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Active" },
        {valueactive: 0, name_active: "Disable" }
      ],
      
      dialog: false,
      dialogDelete: false,
      search:'',
      headers: [
        { text: 'Analysis Group', value: 'GROUP_ANALYSIS' },
        { text: 'Status', value: 'STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'USERNAME_CREATE' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'USERNAME_UPDATE' },
        { text: 'Image', value: 'image' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dataTable: [],
      editedIndex: -1,
      file: "",
      previewImage: "",
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add '+this.$store.state.title : 'Update '+this.$store.state.title
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      selectfile(event) {
        this.file = event;
        if (event) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(event);
        }
      },
        
      onClear() {
        this.previewImage='';
        this.file = null; // bisa juga reset data lainnya jika perlu
      },
      initialize () {
        this.tableLoading = true;
        axios.get("analysis_group",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            this.dataTable = decryptionData(response.data.token);
            // this.dataTable = response.data;
            console.log(response.data);
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      deleteItem (item) {
        this.id_seq = item
        this.editedIndex = this.dataTable.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.dataTable.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "analysis_group/delete",
          data: {
            seq_id: this.id_seq
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      // editItem (item) {
      //   this.id_seq = item
      //   this.editedIndex = 1
      //   console.log('item edit')
      //   console.log(item)

      //   this.editedItem = Object.assign({}, item)
      //   this.dialog = true
      //   axios({
      //     method: "put",
      //     url: "analyzer_person_Id",
      //     data: {
      //       id: item
      //     },
      //     headers:{'auth-token':localStorage.getItem('token_app')},
      //     dataType: 'json'
      //   })
      //   .then(async (response) => {
      //       console.log(response.data);
      //       let result = decryptionData(response.data.token);
      //       const data = result.data;
      //       this.id_seq = data.SEQ_ID 
      //       this.analysisGroup = data.USER_DISPLAY_NAME 
      //       this.statusactive = data.USER_STATUS 
      //       if (data.PRS_IMAGE) {
      //         const imageUrl = data.PRS_IMAGE;
      //         try {
      //           const response = await axios.get(imageUrl, {
      //             responseType: 'blob',
      //           });

      //           const blob = response.data;
      //           const filename = imageUrl.split('/').pop();
      //           const file = new File([blob], filename, { type: blob.type });
      //           this.file = file;
      //           this.previewImage = URL.createObjectURL(file); // opsional preview
      //         } catch (err) {
      //           console.error("Gagal ambil gambar dari server:", err);
      //           this.file = null;
      //           this.previewImage = '';
      //         }
      //       } else {
      //         this.file = null;
      //         this.previewImage = '';
      //       }


      //       setTimeout(() =>{
      //         this.loading = false
      //       },1000)
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //   })
      // },
      editItem(item) {
        this.editedIndex = this.dataTable.indexOf(item)
        this.dialog = true

        // isi form dari data table
        this.id_seq = item.SEQ_ID
        this.analysisGroup = item.GROUP_ANALYSIS
        this.statusactive = item.STATUS

        // image preview
        if (item.PRS_IMAGE) {
          this.previewImage = item.PRS_IMAGE
        } else {
          this.previewImage = ''
        }

        this.file = null
      },

      
      async save () {
        const isValid = this.$refs.form.validate();
        const formData = new FormData();
        formData.append('image', this.file);
        formData.append('seq_id', this.id_seq);
        formData.append('analysis_group', this.analysisGroup);
        formData.append('status', this.statusactive);
        for (var item of formData.entries()) {
            console.log(item[0]+ ', ' + item[1]); 
        }
        if (this.editedIndex > -1) {
            if (isValid) {

              this.btnload = true
              await axios.put("analysis_group/update",formData, 
                { headers:
                  {
                    'auth-token':localStorage.getItem('token_app'),
                    'Content-Type': 'multipart/form-data',
                    //'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                  }
                },
                {dataType: 'json'},
                
                )
              .then((response) => {
                    var status = response.data.status
                    var messages = response.data.msg
                    if(status == 200){
                      this.initialize();
                      this.$router.push('/GroupAnalysis');
                      this.alertSuccess = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                    }else{
                        this.alertFailed = true;
                        this.alert_err_attention =  messages;
                        this.btnload = false
                    } 
                })
              .catch((e) => {
                    switch (e.response.status) {
                        case 404:
                              this.$refs.alert.error_login(404);
                            break;
                        case 403:
                              this.$refs.alert.error_login(403);
                            break;
                        case 400:
                              this.alertFailed = true;
                              this.alert_err_attention =  e.response.data.msg;
                            break;
                        default:
                            console.log('some other error');  // end up here all the time
                            break;
                        }
                this.errors=e.response.data.msg;
              });
            }
        } else {
          if (isValid) {

            this.btnload = true
            this.dataTable.push(this.editedItem)
            await axios.post("analysis_group/insert",formData, 
              { headers:
                {
                  'auth-token':localStorage.getItem('token_app'),
                  'Content-Type': 'multipart/form-data',
                  // 'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                }
              },
              {dataType: 'json'},
              
              )
            .then((response) => {
                  var status = response.data.status
                  var messages = response.data.msg
                  if(status == 200){
                    this.initialize();
                    this.$router.push('/GroupAnalysis');
                    this.alertSuccess = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                  }else{
                      this.alertFailed = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                  } 
              })
            .catch((e) => {
                  switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.data.msg;
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                      }
              this.errors=e.response.data.msg;
            });
            this.close()

          }
        }
      },
      close () {
        this.file='';
        this.image_url='';
        this.analysisGroup='';
        this.onClear() 
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
    },
  }